import { Badge } from "@/components/ui/badge";
import { ReservationForm } from "@/components/ReservationForm";
import { ReservationSuccessAnimation } from "@/components/ReservationSuccessAnimation";
import { useAnalyticsContext } from "@/components/AnalyticsProvider";
import { useEffect, useState, useCallback } from "react";
import { sectionContent } from "@/config/contentConfig";

export const Contact = () => {
  const { trackPageView } = useAnalyticsContext();
  const [showSuccess, setShowSuccess] = useState(false);
  const handleSuccess = useCallback(() => setShowSuccess(true), []);
  
  // Vérifier si un château/sumo est pré-sélectionné via l'URL
  const urlParams = new URLSearchParams(window.location.search);
  const preSelectedProduct = urlParams.get('product') || urlParams.get('chateau') || 
    (window.location.pathname === '/sumos' ? 'sumos' : undefined);

  // Track section view
  useEffect(() => {
    trackPageView('#contact');
  }, [trackPageView]);
  return (
    <>
    <section id="contact" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        
        {/* Section Header */}
        <div className="text-center mb-16">
          <Badge className="mb-4 gradient-primary text-white border-0">{sectionContent.contact.badge}</Badge>
          <h2 className="text-4xl md:text-5xl font-display font-bold mb-6">
            <span className="bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
              {sectionContent.contact.title}
            </span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            {sectionContent.contact.description}
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <ReservationForm preSelectedChateau={preSelectedProduct} onSuccess={handleSuccess} />
        </div>
      </div>
    </section>
    {showSuccess && (
      <ReservationSuccessAnimation onComplete={() => setShowSuccess(false)} />
    )}
    </>
  );
};